import {
  CreateMarketCategoryDto,
  MarketCategoryDto,
  PatchMarketCategoryDto,
} from '@careapp-group/ng-sdk';
import { BaseFilterType, CaEntityActionsFactory } from '../entity-state/entity-actions-factory';

class MarketManagementCategoryActions extends CaEntityActionsFactory<
  MarketCategoryDto,
  CreateMarketCategoryDto,
  PatchMarketCategoryDto,
  BaseFilterType
> {
  constructor() {
    super(`MarketManagementCategories`);
  }
}

export const MarketManagementCategories = new MarketManagementCategoryActions();
